.modalContainer {
  font-family: Galano Grotesque, sans-serif !important;
  position: absolute;
  z-index: 10000;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(49, 49, 49, 0.6);

  button {
    font-family: Galano Grotesque, sans-serif !important;
  }
}

.smallModalLargeButton {
  max-width: 400px;

  & button {
    width: 174px;
  }
}

.modal {
  white-space: normal;
  border-radius: 12px;
  padding: 24px;
  max-width: 90%;
  box-sizing: border-box;

  @include themify($themes) {
    @if $theme == "dark" {
      background-color: themed("background");
    } @else {
      background-color: #fff;
    }
    border: 1px solid themed('neutral-secondary');
    color: themed('font_primary');
  }

  .headerClose {
    z-index: 100;
    @include themify($themes) {
      color: themed('font_primary');
    }
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 600;
    font-size: 11px;
    text-transform: uppercase;

    & > svg:only-child {
      margin: 0 0 -14px auto;
    }

    h3 {
      display: flex;
      flex: 1;
      align-items: center;
      font-size: 14px;
      letter-spacing: 2.5px;
      text-transform: uppercase;
    }

    .close {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 20px 20px 0 0;
      cursor: pointer;
      font-size: 16px;
      pointer-events: auto;
    }
  }

  .subHeader {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 11px 20px;
    font-size: 12px;
    letter-spacing: -0.2px;
    line-height: 17px;
    text-align: center;
    white-space: break-spaces;
  }

  .body {
    display: block;
    max-height: calc(100vh - 208px);

    .ModalSubtitle {
      padding: .5em 0 1.5em;
      margin: 0;
      font-size: 14px;
      font-weight: 700;
      line-height: 17px;
      text-align: left;
    }

    .ModalSection {
      margin: 20px auto;
      font-size: 14px;
      line-height: 20px;
    }

    p {
      text-align: center;

      &.textAlignLeft {
        text-align: left;
      }
    }

    .textAlignCenter {
      text-align: center;
    }
  }

  .footer {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;

    button {
      margin: 0;
    }

  }
}


$fullPageModalHeaderHeight: 136px;

.fullPageModal {
  position: absolute;
  z-index: 3000;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #EBECF2;


  .header {
    display: flex;
    width: 100%;
    height: $fullPageModalHeaderHeight;
    flex-direction: column;
    justify-content: center;
    padding: 0 70px;
    background: linear-gradient(224.46deg, #3A495F 0%, #1B2331 100%);
    line-height: normal;
  }

  .title {
    display: flex;
    justify-content: space-between;
    padding: 38px 0 29px 0;
    color: #ffffff;

    .titleText {
      font-size: 35px;
      letter-spacing: 0.44px;
    }

    .close {
      display: flex;
      width: 39px;
      height: 39px;
      align-items: center;
      justify-content: center;
      border: 1px solid #d8dae5;
      border-radius: 50%;
      cursor: pointer;
      transition: background-color .3s linear;

      &:hover {
        background-color: rgba(0, 0, 0, 20%);
      }
    }
  }

  .buttons {
    display: flex;
    color: #9EA0AB;
    font-size: 10px;
    letter-spacing: 1.99px;
    text-transform: uppercase;

    & > div {
      padding-bottom: 17px;
      cursor: pointer;

      &:not(:last-child) {
        margin-right: 40px;
      }
    }

    div.selected {
      border-bottom: 2px solid;
      color: #ffffff;
      cursor: default;
    }
  }

  .page {
    display: flex;
    overflow: auto;
    width: 100%;
    height: calc(100% - #{$fullPageModalHeaderHeight});
    justify-content: center;
  }
}

.svg {
  padding-right: 12px;
}
